export enum ToolPromptType {
  moderatorBotModerationTaskCompleted = 'moderator_bot_moderation_task_completed',
  moderatorBotUserTalkingOffTopic = 'moderator_bot_user_talking_off_topic',
  formCompletionBotFormElementUpdated = 'form_completion_bot_form_element_updated',
  formCompletionBotResearch = 'form_completion_bot_research',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const ToolPromptTypeMap = {
  moderatorBotModerationTaskCompleted:
    ToolPromptType.moderatorBotModerationTaskCompleted,
  moderatorBotUserTalkingOffTopic:
    ToolPromptType.moderatorBotUserTalkingOffTopic,
  formCompletionBotFormElementUpdated:
    ToolPromptType.formCompletionBotFormElementUpdated,
  formCompletionBotResearch: ToolPromptType.formCompletionBotResearch,
}

export const ToolPromptTypeReverseMap = {
  [ToolPromptType.moderatorBotModerationTaskCompleted]:
    'moderator_bot_moderation_task_completed',
  [ToolPromptType.moderatorBotUserTalkingOffTopic]:
    'moderator_bot_user_talking_off_topic',
  [ToolPromptType.formCompletionBotFormElementUpdated]:
    'form_completion_bot_form_element_updated',
  [ToolPromptType.formCompletionBotResearch]: 'form_completion_bot_research',
}

export const ToolPromptTypeList = [
  ToolPromptType.moderatorBotModerationTaskCompleted,
  ToolPromptType.moderatorBotUserTalkingOffTopic,
  ToolPromptType.formCompletionBotFormElementUpdated,
  ToolPromptType.formCompletionBotResearch,
]

export const ToolPromptTypeNames = Object.keys(ToolPromptTypeMap)
